import { pxToRem } from '@theme/utils/sizing';

export const elevation = {
  light: {
    none: 'none',
    xsmall: '0px 1px 2px rgba(0, 0, 0, 0.20)',
    small: '0px 2px 4px rgba(0, 0, 0, 0.20)',
    medium: `0 0 ${pxToRem(32)} rgba(0, 0, 0, 0.20)`,
    large: '0px 8px 16px rgba(0, 0, 0, 0.20)',
    xlarge: '0px 12px 24px rgba(0, 0, 0, 0.20)',
  },
  dark: {
    none: 'none',
    xsmall: '0px 2px 2px rgba(255, 255, 255, 0.40)',
    small: '0px 4px 4px rgba(255, 255, 255, 0.40)',
    medium: '0px 6px 8px rgba(255, 255, 255, 0.40)',
    large: '0px 8px 16px rgba(255, 255, 255, 0.40)',
    xlarge: '0px 12px 24px rgba(255, 255, 255, 0.40)',
  },
};

export default {
  elevation,
};
